export default "__VITE_ASSET__BSRUaDfl__"